import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import wechatCustomerService from '@assets/image/download/WechatCusomerService.png';

const SUPPORT_EMAIL = 'bjpineconego@gmail.com';

const Support = () => {
  return (
    <div>
      <Card>
        <div className='padding2em'>
          <Card.Title>
            <h3>客服与帮助</h3>
          </Card.Title>
          <Card.Text>
            <div className='vPrivacy-content'>
              <p className='vPrivacy-intro'>
                无论您在使用松果网网站还是松果Go App
                时遇到问题，都可以通过以下方式联系我们。
                客服工作时间为美国洛杉矶时间 12:00 –
                20:00，非工作时间的留言会在下一个工作日回复。
              </p>
              <div className='vPrivacy-desc'>
                <dl>
                  <dt>微信客服（推荐）</dt>
                  <dd>
                    包裹查询、运费咨询、修改地址等日常问题，请扫描下方二维码添加客服微信，客服将尽快与您联系。
                    <div className='mt-3'>
                      <img
                        className='img-fluid support-wechat-qr'
                        src={wechatCustomerService}
                        alt='客服微信二维码'
                      />
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>电子邮件</dt>
                  <dd>
                    账号问题、投诉建议、数据与隐私相关请求，请发送邮件至{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    ，并在正文注明您的注册邮箱或手机号，以便我们核实身份。我们会在
                    2 个工作日内回复。
                  </dd>
                </dl>
                <dl>
                  <dt>常见问题</dt>
                  <dd>
                    <div>
                      · 不知道怎么下单？请查看
                      <Link to='/guide'>新手指南</Link>。
                    </div>
                    <div>
                      · 想了解运费？请使用
                      <Link to='/price'>运费计算</Link>。
                    </div>
                    <div>
                      · 想了解两种服务的区别？请查看
                      <Link to='/express'>松果极速</Link>与
                      <Link to='/save'>松果极省</Link>。
                    </div>
                    <div>
                      · 需要删除账号？请查看
                      <Link to='/delete-account'>删除账号</Link>。
                    </div>
                    <div>
                      · 想了解我们如何处理您的信息？请查看
                      <Link to='/privacy'>隐私政策</Link>。
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>联系时请准备</dt>
                  <dd>
                    为了更快解决问题，请尽量提供：注册邮箱或手机号、松果运单号或国内快递单号、问题截图。
                  </dd>
                </dl>
              </div>

              <h3 className='mt-5'>Support</h3>
              <div className='vPrivacy-desc'>
                <dl>
                  <dt>WeChat (recommended)</dt>
                  <dd>
                    For parcel tracking, shipping quotes and address changes,
                    scan the QR code above to add our customer service account
                    on WeChat. Support hours are 12:00 PM – 8:00 PM Los Angeles
                    time (Pacific Time).
                  </dd>
                </dl>
                <dl>
                  <dt>Email</dt>
                  <dd>
                    For account issues, complaints, and data or privacy
                    requests, email{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> from
                    your registered address. We reply within 2 business days.
                  </dd>
                </dl>
                <dl>
                  <dt>Useful pages</dt>
                  <dd>
                    <Link to='/delete-account'>Delete your account</Link> ·{' '}
                    <Link to='/privacy'>Privacy policy</Link>
                  </dd>
                </dl>
              </div>
            </div>
          </Card.Text>
        </div>
      </Card>
    </div>
  );
};

export default Support;
